var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12", attrs: { id: "app" } },
    [
      _c("vdtnet-table", {
        ref: "table",
        attrs: {
          fields: _vm.fields,
          opts: _vm.options,
          "select-checkbox": 0,
          "container-classname": ""
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }